import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Typography,
    Grid,
    CircularProgress,
    Tooltip
} from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import React, { useEffect } from "react";
import CodeIcon from '@material-ui/icons/Code';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonIcon from '@material-ui/icons/Person';
import { get } from '../../utils/network';
import version from '../../version';
import DoneRoundedIcon from "@material-ui/icons/DoneRounded";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

const ServiceStatusIcon = ({ state }) => {
    if (state === 'ok') return <Tooltip title="ok"><DoneRoundedIcon style={{ color: "#2ecc71" }} /></Tooltip>;
    if (state === 'unreachable') return <Tooltip title="unreachable"><WarningRoundedIcon style={{ color: "#f39c12" }} /></Tooltip>;
    return <Tooltip title={state || 'error'}><CloseRoundedIcon style={{ color: "#e74c3c" }} /></Tooltip>;
};

const Panel = ({ devMode }) => {
    const [status, setStatus] = React.useState(null);

    useEffect(() => {
        get('dev/status')
            .then(res => res.json())
            .then(res => {
                setStatus(res.message);
            })
            .catch(err => console.log(err));
    }, []);

    return (
        <div style={{ padding: "2rem" }}>
            <Typography variant="h4" style={{ marginBottom: "0.5rem" }}>
                Panel de Desarrollo
            </Typography>
            <Typography variant="subtitle1" style={{ marginBottom: "2rem" }}>
                Devmode: {devMode ? "Activado" : "Desactivado"}
            </Typography>

            <Grid container spacing={3}>

                {/* Logs */}
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Card style={{ padding: "0.25rem", borderRadius: 12, boxShadow: "0 2px 10px rgba(0,0,0,0.08)" }}>
                        <CardHeader
                            avatar={<CodeIcon />}
                            title="Logs"
                        />
                        <CardContent>
                            <Typography variant="body2">
                                Visualiza los logs del sistema por fecha.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button
                                disabled={!devMode}
                                variant="contained"
                                color="primary"
                                component={RouterLink}
                                to="dev/logs"
                            >
                                Ir a Logs
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>

                {/* Users */}
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Card style={{ padding: "0.25rem", borderRadius: 12, boxShadow: "0 2px 10px rgba(0,0,0,0.08)" }}>
                        <CardHeader
                            avatar={<PersonIcon />}
                            title="Usuarios"
                        />
                        <CardContent>
                            <Typography variant="body2">
                                Accede al ABM de usuarios del sistema.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button
                                disabled={!devMode}
                                variant="contained"
                                color="primary"
                                component={RouterLink}
                                to="dev/users"
                            >
                                Alta de usuarios
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>

                {/* Status */}
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Card style={{ padding: "0.25rem", borderRadius: 12, boxShadow: "0 2px 10px rgba(0,0,0,0.08)" }}>
                        <CardHeader
                            avatar={<FavoriteIcon />}
                            title="Status"
                        />

                        <CardContent style={{padding: 16}}>
                            <Typography variant="body2">Versiones:</Typography>
                            {status ? (
                                <>
                                    <Typography variant="body2">API: {status.Version}</Typography>
                                    <Typography variant="body2" style={{ marginBottom: 12 }}>
                                        Cliente: {version.version}
                                    </Typography>
                                </>
                            ) : (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <CircularProgress size={18} style={{ marginRight: 8 }} />
                                    Cargando...
                                </div>
                            )}

                            <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
                                Servicios:
                            </Typography>

                            {status ? (
                                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                                    {["database", "storage", "search"].map((category) => (
                                        <div
                                            key={category}
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Typography variant="body2">{status[category].type}</Typography>

                                            <ServiceStatusIcon state={status[category].status} />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <CircularProgress size={18} style={{ marginRight: 8 }} />
                                    Cargando...
                                </div>
                            )}

                        </CardContent>
                        <CardActions sx={{ display: "none" }} />
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default Panel;
